import { useMemo, useState } from 'react'

import { Display } from '@joor/design-system'

import {
  AgGridFilters,
  AgGridFiltersTypes,
  FilterDef,
  OptionProps,
} from '../agGridFilters.types'
import { SelectedFilters } from './SelectedFilters'
import { removeFilter } from './selectedFilters.utils'

type UseSelectedFiltersReturnType = {
  selectedFilters: AgGridFilters<string>
  selectedFiltersOption: OptionProps
  handleUpdateFilters: (name: string, value: AgGridFiltersTypes) => void
  handleRemoveFilter: (name: string, value?: string) => void
  handleResetFilters: () => void
}

export const useSelectedFilters = (
  filterDefs: FilterDef[],
): UseSelectedFiltersReturnType => {
  const [selectedFilters, setSelectedFilters] = useState(
    {} as AgGridFilters<string>,
  )

  const handleUpdateFilters = (
    name: string,
    value: AgGridFiltersTypes,
  ): void => {
    setSelectedFilters((currentFilters) => ({
      ...currentFilters,
      [name]: value,
    }))
  }

  const handleRemoveFilter = (name: string, value?: string): void => {
    setSelectedFilters((currentFilters) =>
      removeFilter(currentFilters, name, value),
    )
  }

  const handleResetFilters = () => {
    setSelectedFilters({})
  }

  const selectedFiltersOption = useMemo(
    () => ({
      content: (
        <Display>
          <SelectedFilters
            filterDefs={filterDefs}
            filters={selectedFilters}
            onRemoveFilter={handleRemoveFilter}
          />
        </Display>
      ),
    }),
    [filterDefs, selectedFilters],
  )

  return {
    selectedFilters,
    selectedFiltersOption,
    handleUpdateFilters,
    handleRemoveFilter,
    handleResetFilters,
  }
}
